import { gql } from '@apollo/client'

export const GET_PRODUCT_BY_SLUG = gql`
    query GetProductBySlug ($slug: String!, $language: Language) {
        productBySlug (slug: $slug) {
            id,
            name,
            version,
            slug,
            starting_price,
            video_link,
            company {
                id,
                slug,
                company_constraints {
                    product_count
                    commission
                    has_lead
                    has_download
                    has_cloud
                    has_services
                }
                logo {
                    url,
                    width,
                    height
                }
                name,
                rating,
                product_count,
                paymentMethods {
                    __typename,
                    id,
                    config {
                        ...on StripeConfig {
                            api_key
                            webhook_secret
                            publishable_key
                        },
                        ...on PayPalConfig {
                            client_id
                            client_secret
                            webhook_id
                        }
                    },
                    is_active,
                    payment_method
                }
            },
            last_updated,
            is_popular,
            is_featured,
            is_free,
            is_cloud_product,
            is_on_request_only,
            cloud_starting_price_period,
            cloud_starting_price_net
            is_active,
            is_approved,
            compatibilities {
                id,
                software,
                version
            },
            demos {
                id,
                software,
                url,
                is_public_download
            },
            rating_total,
            rating_count,
            rating_total_functionality,
            rating_total_documentation,
            rating_total_support,
            features(language: $language) {
                id,
                description,
                name,
                language
            }
            descriptions(language: $language) {
                id,
                description,
                language,
                intro
            }
            categories {
                id,
                category
            }
            logo {
                url,
                width,
                height
            }
            medias {
                id,
                ordering,
                filename,
                media {
                    url,
                    width,
                    height
                }
            }
            licenses {
                id,
                prices {
                    id,
                    currency,
                    quantity_to,
                    quantity_from,
                    price_net
                },
                names {
                    id,
                    name,
                    language
                }
            }
            tags {
                id,
                tag
            }
            languages {
                id,
                language
            }
        }
    }
`

export const GET_PRODUCT = gql`
    query GetProduct ($id: ID!, $language: Language) {
        product (id: $id) {
            id,
            name,
            version,
            slug,
            video_link,
            company {
                id,
                slug,
                logo {
                    url,
                    width,
                    height
                }
                name,
                rating,
                product_count,
                paymentMethods {
                    __typename,
                    id,
                    config {
                        ...on StripeConfig {
                            api_key
                            webhook_secret
                            publishable_key
                        },
                        ...on PayPalConfig {
                            client_id
                            client_secret
                            webhook_id
                        }
                    },
                    is_active,
                    payment_method
                }
            },
            last_updated,
            is_popular,
            is_featured,
            is_active,
            is_approved,
            is_free,
            is_cloud_product,
            is_on_request_only,
            cloud_starting_price_period,
            cloud_starting_price_net
            compatibilities {
                id,
                software,
                version
            },
            demos {
                id,
                software,
                url,
                is_public_download
            },
            rating_total,
            rating_count,
            rating_total_functionality,
            rating_total_documentation,
            rating_total_support,
            starting_price,
            features(language: $language) {
                id,
                description,
                name,
                language
            }
            descriptions(language: $language) {
                id,
                description,
                language,
                intro
            }
            categories {
                id,
                category
            }
            logo {
                url,
                width,
                height
            }
            medias {
                id,
                ordering,
                filename,
                media {
                    url,
                    width,
                    height
                }
            }
            licenses {
                id,
                prices {
                    id,
                    currency,
                    quantity_to,
                    quantity_from,
                    price_net
                },
                names {
                    id,
                    name,
                    language
                }
            }
            tags {
                id,
                tag
            }
            languages {
                id,
                language
            }
        }
    }
`

// This Query is used for mutations in /admin or /seller/dashboard pages
export const GET_SELLER_PRODUCT = gql`
    query GetSellerProduct ($id: ID!, $language: Language) {
        product (id: $id) {
            id,
            name,
            version,
            last_updated,
            video_link,
            is_active,
            is_free,
            is_cloud_product,
            is_on_request_only,
            cloud_starting_price_period,
            cloud_starting_price_net,
            starting_price,
            slug,
            company {
                id,
                subscription_type,
                company_constraints {
                    product_count
                    commission
                    has_lead
                    has_download
                    has_cloud
                    has_services
                },
                activeProductCount,
                paymentMethods {
                    __typename,
                    id,
                    config {
                        ...on StripeConfig {
                            api_key
                            webhook_secret
                            publishable_key
                        },
                        ...on PayPalConfig {
                            client_id
                            client_secret
                            webhook_id
                        }
                    },
                    is_active,
                    payment_method
                }
            },
            compatibilities {
                id,
                software,
                version
            },
            demos {
                id,
                software,
                url,
                is_public_download
            },
            features(language: $language) {
                id,
                description,
                name,
                language
            }
            descriptions(language: $language) {
                id,
                description,
                language,
                intro
            }
            categories {
                id,
                category
            }
            logo {
                url,
                width,
                height
            }
            medias {
                id,
                ordering,
                filename,
                media {
                    url,
                    width,
                    height
                }
            }
            licenses {
                id,
                prices {
                    id,
                    currency,
                    quantity_to,
                    quantity_from,
                    price_net
                },
                names {
                    id,
                    name,
                    language
                }
            }
            tags {
                id,
                tag
            }
            languages {
                id,
                language
            }
        }
    }
`

// This Query is used for mutations in /admin or /seller/dashboard pages
export const GET_DISTRIBUTOR_PRODUCT = gql`
    query GetDistributorProduct ($id: ID!, $language: Language) {
        product (id: $id) {
            id,
            name,
            version,
            last_updated,
            video_link,
            is_active,
            is_approved,
            is_free,
            is_cloud_product,
            is_on_request_only,
            cloud_starting_price_period,
            cloud_starting_price_net,
            starting_price,
            slug,
            commission,
            company {
                id,
                subscription_type,
                company_constraints {
                    product_count
                    commission
                    has_lead
                    has_download
                    has_cloud
                    has_services
                },
                activeProductCount,
                paymentMethods {
                    __typename,
                    id,
                    config {
                        ...on StripeConfig {
                            api_key
                            webhook_secret
                            publishable_key
                        },
                        ...on PayPalConfig {
                            client_id
                            client_secret
                            webhook_id
                        }
                    },
                    is_active,
                    payment_method
                }
            },
            compatibilities {
                id,
                software,
                version
            },
            demos {
                id,
                software,
                url,
                is_public_download
            },
            features(language: $language) {
                id,
                description,
                name,
                language
            }
            descriptions(language: $language) {
                id,
                description,
                language,
                intro
            }
            categories {
                id,
                category
            }
            logo {
                url,
                width,
                height
            }
            medias {
                id,
                ordering,
                filename,
                media {
                    url,
                    width,
                    height
                }
            }
            licenses {
                id,
                prices {
                    id,
                    currency,
                    quantity_to,
                    quantity_from,
                    price_net
                },
                names {
                    id,
                    name,
                    language
                }
            }
            tags {
                id,
                tag
            }
            languages {
                id,
                language
            }
        }
    }
`

// This Query is used for mutations in /admin or /seller/dashboard pages
export const GET_ADMIN_PRODUCT = gql`
    query GetAdminProduct ($id: ID!, $language: Language) {
        product (id: $id) {
            id,
            name,
            version,
            last_updated,
            video_link,
            is_popular,
            is_featured,
            is_active,
            is_free,
            is_cloud_product,
            is_on_request_only,
            cloud_starting_price_period,
            cloud_starting_price_net,
            starting_price,
            is_approved,
            slug,
            commission,
            company {
                id,
                subscription_type,
                company_constraints {
                    product_count
                    commission
                    has_lead
                    has_download
                    has_cloud
                    has_services
                },
                activeProductCount,
                paymentMethods {
                    __typename,
                    id,
                    config {
                        ...on StripeConfig {
                            api_key
                            webhook_secret
                            publishable_key
                        },
                        ...on PayPalConfig {
                            client_id
                            client_secret
                            webhook_id
                        }
                    },
                    is_active,
                    payment_method
                }
            },
            compatibilities {
                id,
                software,
                version
            },
            demos {
                id,
                software,
                url,
                is_public_download
            },
            features(language: $language) {
                id,
                description,
                name,
                language
            }
            descriptions(language: $language) {
                id,
                description,
                language,
                intro
            }
            categories {
                id,
                category
            }
            logo {
                url,
                width,
                height
            }
            medias {
                id,
                ordering,
                filename,
                media {
                    url,
                    width,
                    height
                }
            }
            licenses {
                id,
                prices {
                    id,
                    currency,
                    quantity_to,
                    quantity_from,
                    price_net
                },
                names {
                    id,
                    name,
                    language
                }
            }
            tags {
                id,
                tag
            }
            languages {
                id,
                language
            }
        }
    }
`
